import { parseDate, StateLabel } from "@delibrandev/utils";
import { FiShoppingBag } from "react-icons/fi";
import { useSelector } from "react-redux";

export const History = () => {
  const data = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel.data.Orders,
  );
  const OrderRow = ({ data }) => {
    return (
      <div className="order-row">
        <div className="order-info">
          <div className="order-icon">
            <FiShoppingBag size={"1.7rem"} />
          </div>
          <div className="order-detail">
            <div>
              <b>
                {(data?.SalesChannel?.identifier || "") + "-" + data.number}
              </b>
            </div>
            <div>{parseDate(data.createdAt)}</div>
          </div>
        </div>
        <div style={{ flexDirection: "column" }}>
          <div className="order-row-state">
            Estado del pedido
            <StateLabel state={data.status} />
          </div>
          <div className="order-row-state">
            Estado del pago
            <StateLabel state={data.paymentStatus} />
          </div>
        </div>
        <div className="order-row-total">
          <div style={{ fontSize: "0.8rem" }}>Total</div>
          <div>
            <b>
              {data.amounts
                ? Number(data.amounts.total).toFixed(2) + " €"
                : "Pendiente de revisión"}
            </b>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="orderHistoryContainer">
      {!data?.length && (
        <p className="clientHistoryEmpty">
          Este cliente todavía no tiene pedidos en este negocio.
        </p>
      )}
      {data?.map((order) => (
        <OrderRow key={order.id || order.number} data={order} />
      ))}
    </div>
  );
};
